import type { NotificationType } from "@typings/entities/notifications";
import { REGISTER_TYPE_LABELS } from "@typings/entities/registers/enums";
import { SAMPLE_TYPE_LABELS } from "@typings/entities/samples/enums";

export const NOTIFICATION_TYPE_MAP: Record<
  NotificationType,
  {
    label: string;
    filterLabel: string;
  }
> = {
  individual: {
    label: "Indivíduo",
    filterLabel: "Indivíduos",
  },
  release: {
    label: "Soltura",
    filterLabel: "Solturas",
  },
  taxonomic_group: {
    label: "Grupo Taxonômico",
    filterLabel: "Grupos Taxonômicos",
  },
  register: {
    label: "Registro",
    filterLabel: "Registros",
  },
  sample: {
    label: "Amostra",
    filterLabel: "Amostras",
  },
};

export const NOTIFICATION_FILTER_OPTIONS = [
  { value: "", label: "Todas" },
  { value: "release", label: "Solturas" },
  { value: "individual", label: "Indivíduos" },
  { value: "sample", label: "Amostras" },
  { value: "register", label: "Registros" },
  { value: "taxonomic_group", label: "Grupos Taxonômicos" },
] as const;

const TRANSLATION_MAP = {
  ...REGISTER_TYPE_LABELS,
  ...SAMPLE_TYPE_LABELS,
} as const;

const TYPES_REGEX = new RegExp(
  `\\b(${Object.keys(TRANSLATION_MAP).join("|")})\\b`,
  "gi",
);

export function translateNotificationDescription(description: string): string {
  return description.replace(
    TYPES_REGEX,
    (match) =>
      TRANSLATION_MAP[match.toLowerCase() as keyof typeof TRANSLATION_MAP] ||
      match,
  );
}

export function getNotificationRoute(notification: {
  type: NotificationType;
  individualId?: string;
  releaseId?: string;
  taxonomicGroupId?: string;
  registerId?: string;
  sampleId?: string;
}): string {
  switch (notification.type) {
    case "individual":
      return notification.individualId
        ? `/individuals/${notification.individualId}`
        : "/individuals";
    case "release":
      return notification.releaseId
        ? `/managing-releases/${notification.releaseId}`
        : "/managing-releases";
    case "taxonomic_group":
      return "/taxonomic-groups";
    case "register":
      return notification.registerId
        ? `/registers/${notification.registerId}`
        : "/registers";
    case "sample":
      return notification.sampleId
        ? `/samples/${notification.sampleId}`
        : "/samples";
    default:
      return "/";
  }
}
